var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoaderCard",class:{'small': _vm.small}},[_c('b-loading',{attrs:{"is-full-page":false},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }